import { Component, Emit, Prop, Vue,Watch } from 'vue-property-decorator';
import store from '@/assets/common/store/store';
import { cropList} from "@/types/Component";
import EditModal from '@/assets/common/Modal/EditModal/EditModal.vue';
import ReferencePlantingModal from '@/assets/common/Modal/ReferencePlantingListModal/ReferencePlantingListModal.vue';
import PastPerformanceModal from '@/assets/common/Modal/PastPerformanceModal/PastPerformanceModal.vue';
import axios, { AxiosRequestConfig } from 'axios';

interface Worker {
    id: string;
    name: string; 
    multiplicationRate: number;
}

@Component({
    components: {
        EditModal,
        ReferencePlantingModal,
        PastPerformanceModal
    }
})

export default class WorkerGoalRegister extends Vue {
    private apiServerBaseUrl = process.env.VUE_APP_API_URL_BASE
    @Prop({ default: false })
    private readonly isShow!: boolean;
    @Prop()
    private modeType?: string
    @Prop()
    private id?: string | undefined;
    private mode = ''
    private list: any | null = null
    baseUrl = '/admin/reference_planting_list';
    workerGoalBaseUrl = '/admin/worker_goal_registration';
    cropDetails = [] as cropList;
    selectedStartDate= "";
    selectedEndDate= "";
    startDate: string | Date = new Date();
    endDate: string | Date = new Date();
    private referencePlantingList =  [] as any[];
    private selectedTitleId : string | null = null;
    private isButtonDisabled = false;
    private agriFields = [] as any[];
    private plantings = [] as any[];
    private goalTitles = [] as any[];
    private workItems = [] as any[];
    private workunits = [] as any[];
    private workers = [] as any[];
    private referenceGoalList = [] as any[];
    private calculatedValues = [] as any[];
    private selectedPlantingName = '';
    private selectedAgriFieldName = '';
    private selectedWorkItemName = '';
    private selectedWorkerName = '';
    private isSpinnerLoading = false;
    private showEditModal = false;
    private showReferecePlantingModal = false;
    private modalBaseUrl = ''
    private showPastPerformanceModal = false;
    private selectedWorkers: any[] = [];
    private table2Workers: any[] = [];
    private selectedTable2Workers: any[] = [];
    private overallMagnification = 1.0;
    private initialized = false;
    private selectedOption = '過去実績' 
    private headerText= '過去実績*倍率'
    private previousOption = ''
    private titleName : string | null = null;
    private selectedAgriFieldId : string | null = null;
    private selectedPlantingId : string | null = null;
    private selectedWorkItemId : string | null = null;
    private selectedCropId : string | null = null;
    private selectedWorkUnitId : string | null = null;
    private workerGoalId = ''
    private pastAgriFieldName = ''
    private pastPlantingName = ''
    private pastPlantingArea :number | null = null;
    private pastRemainingArea : number | null = null;
    private subTitle = '';
    private multiplicationRate = 1
    private agriPlantedArea = ''
    private agriRemainingArea = ''
    private selectedWorkUnitName = null
    private isValidationNeeded = true
    private isworkUnitExists = false
    private pastGoalWorkUnitName = ''
    private pastActualWorkUnitName = ''
    private plantingStartDate = ''
    private plantingEndDate = ''
    private workStartDate = ''
    private workEndDate = ''
    private pastAgriFieldId = ''
    private pastPlantingId = ''
    private selectedPastPerformance :any
    private selectedGoalRecordId =null
    private previousSelectedWorkUnitId : string | null = null

    @Watch("isShow")
    handleWorkerGoalModal() {
        if (this.isShow) {
            if (this.modeType) {
                this.mode = this.modeType
            }
            if (this.id) {
                this.workerGoalId = this.id
            }
            this.init()
        }
    }

    get workerGoalRegisterModalOpen():boolean{
        return(
            this.showEditModal ||
            this.showReferecePlantingModal ||
            this.showPastPerformanceModal
        )
    }
    
    private init() {
        this.initCheck();
        this.getWorkUnits();
        this.getWorkers();
        this.getAgriFields();
        this.getWorkItems();
        this.getPlantings();
        this.getCrops();
        this.callMountedLogic()
        this.subTitle = this.mode === 'copy' ? '（流用）': '';
        this.onOverallMagnificationChanged();
    }

    private initCheck() {
        this.titleName = null;
        this.selectedAgriFieldId = null;
        this.selectedPlantingId = null;
        this.selectedWorkItemId = null;
        this.selectedCropId = null;
        this.selectedWorkUnitId = null;
        this.selectedStartDate = "";
        this.selectedEndDate = "";
        this.table2Workers = [];
        this.workers = [];
        this.pastPlantingName = '';
        this.pastAgriFieldName = '';
        this.pastPlantingArea = null;
        this.pastRemainingArea = null;
        this.selectedWorkers = [];
        this.selectedTable2Workers = [];
        this.selectedOption = '過去実績' 
        this.pastGoalWorkUnitName = ''
        this.selectedWorkUnitName = null
        this.selectedPastPerformance =''
        this.selectedGoalRecordId = null
        this.overallMagnification = 1.0
        this.previousSelectedWorkUnitId = null;
    }
    
    closeModal() {
        if (store.getters.isInputChanged) {
            if (window.confirm("変更内容を破棄します。よろしいですか？")) {
                store.dispatch("doUpdateIsInputChanged", false);
                this.initCheck();
            } else {
                return;
            }
        }
        this.$emit('update:isShow', false);
    }
        
    @Emit('inputChanged')
    private inputChanged(){
        if (store.getters.isInputChanged == false) {
            this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    openPastPerformanceModal(): void {
        const errmsg: string[] = [
            this.selectedCropId == null ? '作目を選択してください。' : '',
            this.selectedWorkItemId == null ? '作業項目を選択してください。' : '',
            this.selectedWorkUnitId == null ? '単位を選択してください。' : ''
        ].filter(msg => msg !== '')
        if (errmsg.length) {
            window.alert(errmsg.join('\n'))
        } else {
            const params = {
                cropId: this.selectedCropId,
                plantingId: this.selectedPlantingId,
                agriFieldId: this.selectedAgriFieldId,
                selectedWorkId: this.selectedWorkItemId,
                includeHiddenFlag: false,
                screenName: "PASTPERFORMANCEBYPLANTING",
            }
            this.$apiClient.doRequest('post', `/graphScreenManagement`,params).then(res => {
                this.showPastPerformanceModal = true
            }).catch(error => {
                this.$toasted.error('データの取得に失敗しました。')
            })
        } 
    }

    closePastPerformanceModal(performances: any) {
        if(performances.length>0){
            this.selectedPastPerformance = performances
            this.inputChanged()
            this.selectedGoalRecordId = null;
        }
        if (performances.length > 0) {
            const performanceMap = performances.reduce((map: { [x: string]: any; }, item: { workerId: string; performance: number; }) => {
                map[item.workerId] = item.performance;
                return map;
            }, {});
            this.workers = this.workers.map(worker => {
                return {
                    ...worker,
                    pastGoalValue:null,
                    pastActualValue: performanceMap[worker.id] !== undefined ? performanceMap[worker.id] : 0,
                    plantingName: null,
                    plantingId: null,
                    finalGoalValue: null
                };
            });
            this.pastGoalWorkUnitName = ''
            this.pastPlantingName = '';
            this.pastAgriFieldName = '';
            this.pastPlantingArea = null;
            this.pastRemainingArea = null;
        }
        this.showPastPerformanceModal = false
        this.recalculateAllWorkers();
        this.selectedWorkers = []
        this.selectedWorkUnitName = this.workunits.find(item=>item.id==this.selectedWorkUnitId)?.name
    }

    getAgriFields() {
        this.$apiClient.doRequest('get','/agri_fields?with_hidden=true').then((res) => {
            this.agriFields = res.agri_fields
            this.selectedAgriFieldName = this.agriFields.find(item=>item.id==this.selectedAgriFieldId)?.name
        })
    }

    get filteredAgriFields() {
        return this.agriFields.filter(a => this.selectedAgriFieldId == a.id || !a.is_hidden)
    }

    getPlantings() {
        this.$apiClient.doRequest('get','/plantings?with_hidden=true').then((res) => {
            this.plantings = res.plantings.sort((a:any, b:any) => a.name.localeCompare(b.name))
            this.selectedPlantingName = this.plantings.find(item => item.id == this.selectedPlantingId)?.name
        })
    }

    getCrops() {
        this.$apiClient.doRequest("get", `/crops/cropBytenentId`).then(res => {
            this.cropDetails = res.crops;
            this.cropDetails.sort((a:any, b:any) => a.name.localeCompare(b.name));
        });
    }

    getWorkItems() {
        this.$apiClient.doRequest('get','/work_items?with_hidden=true').then((res) => {
            this.workItems = res.work_items
            this.selectedWorkItemName = this.workItems.find(item => item.id == this.selectedWorkItemId)?.name
        })
    }

    get filteredWorkItems() {
        return this.workItems.filter(wi => this.selectedWorkItemId == wi.id || !wi.is_hidden)
    }

    private editWorkUnits() {
        this.modalBaseUrl = '/work_units'
        this.showEditModal = true
    }

    private closeEditModal() {
        this.showEditModal = false
        this.getWorkUnits()
    }

    private openReferencePlantingModal() {
        const errmsg: string[] = [
            this.selectedCropId == null ? '作目を選択してください。' : '',
            this.selectedWorkItemId == null ? '作業項目を選択してください。' : '',
            this.selectedWorkUnitId == null ? '単位を選択してください。' : ''
        ].filter(msg => msg !== '')
        errmsg.length ? window.alert(errmsg.join('\n')) : this.showReferecePlantingModal = true
    }

    updateHeader() {
        const newSelectedOption = this.selectedOption
        if (newSelectedOption === '過去目標') {
            this.previousOption = '過去実績';
        } else if (newSelectedOption === '過去実績') {
            this.previousOption = '過去目標';
        }
        const newPreviousOption = this.previousOption
        const result = window.confirm('生産性目標設定表の値がクリアされます。よろしいですか？');
        setTimeout(() => {
            if (result) {
                this.selectedOption = newSelectedOption;
                this.overallMagnification = 1.0;
                this.applyMultiplierToWorkers()
                this.pastPlantingName = '';
                this.pastAgriFieldName = '';
                this.pastPlantingArea = null;
                this.pastRemainingArea = null;
                this.selectedWorkers=[];
                this.pastGoalWorkUnitName = ''
                this.selectedPastPerformance =''
                this.inputChanged();
            } else {
                this.selectedOption = newPreviousOption;
            }
            this.recalculateAllWorkers();
            this.headerText = this.selectedOption + '*倍率';
        }, 50);
    }

    private applyMultiplierToWorkers() {
        const mergedWorkers = [
            ...this.workers,
            ...this.table2Workers.map(({ name, authority, workerId }) => ({
                name,
                authority,
                id: workerId
            }))
        ];
        this.workers = mergedWorkers.filter((worker, index, self) => index === self.findIndex(w => w.id === worker.id))
        .map(worker => ({
            ...worker,
            pastGoalValue: null,
            pastActualValue: null,
            goalValue: null,
            multiplicationRate: this.overallMagnification,
            finalGoalValue: null,
        }));
        this.table2Workers = [];
        this.workerSort();
    }
      
    private closeReferencePlantingModal(id: any) {
        this.showReferecePlantingModal = false
        if (id !== 'false' && id != "") {
            this.getSelectedGoalRecord(id);
            this.selectedPastPerformance = ''
        }
        setTimeout(() => {
            this.onOverallMagnificationChanged();
            this.recalculateAllWorkers();
            this.workerSort();
        }, 100);
        this.selectedWorkers = []
    }

    private getWorkUnits() {
        this.$apiClient.doRequest('get', '/work_units?with_hidden=true').then(res => {
            this.workunits = res.work_units
        })
    }

    async getWorkers(){
        this.$apiClient.doRequest('get',`${this.workerGoalBaseUrl}`).then(res => {
            this.workers = res.workers
            this.workerSort();
        })
    }

    private workerSort() {
        this.workers.sort((a: any, b: any) => a.name.localeCompare(b.name));
        const workerAdmin = this.workers.filter(user => user.authority === "ADMIN");
        const workerUser = this.workers.filter(user => user.authority === "USER");
        this.workers = workerAdmin.concat(workerUser);
    }

    private getSelectedGoalRecord(id:any){
        this.selectedGoalRecordId = id;
        if(id!=null){
            this.$apiClient.doRequest('get', `${this.baseUrl}/${id}`).then(res => {
                this.pastAgriFieldId = res.referencePlantingDataDetails.agriFieldId
                this.pastPlantingId = res.referencePlantingDataDetails.plantingId
                this.pastPlantingName = res.referencePlantingDataDetails.plantingName
                this.pastAgriFieldName = res.referencePlantingDataDetails.agriFieldName
                this.pastGoalWorkUnitName = res.referencePlantingDataDetails.workUnitName
                this.plantingStartDate = res.referencePlantingDataDetails.plantingStartDate
                this.plantingEndDate = res.referencePlantingDataDetails.plantingEndDate
                this.workStartDate = res.referencePlantingDataDetails.workStartDate
                this.workEndDate = res.referencePlantingDataDetails.workEndDate
                this.pastActualWorkUnitName = res.referencePlantingDataDetails.workUnitName
                
    
                this.workers = this.workers.map((obj2: any) => {
                    const match = res.referencePlantingGoalList.find((obj1: any) => obj1.workerId === obj2.id);
                    return {
                        id: obj2.id,
                        name: obj2.name,
                        authority:obj2.authority,
                        pastGoalValue: match ? (match.pastGoalValue?? 0) : 0, 
                        pastActualValue: match ? (match.performance ?? 0) : 0,
                        plantingName: this.pastPlantingName,
                        plantingId:  this.pastPlantingId,
                    };
                    
                });
                this.getPlantingUsage();
                this.inputChanged();
                  
            }).catch(error=>{
                this.$toasted.error('データの取得に失敗しました。')
            })
        }
    }

    private getPlantingUsage(){
        if(this.pastAgriFieldId!=null && this.pastPlantingId!=null){
            this.$apiClient.doRequest('get', `/agri_fields/remaining_areas?agri_fields=${this.pastAgriFieldId}&work_start_date=${this.plantingStartDate?this.plantingStartDate:this.workStartDate}&work_end_date=${this.plantingEndDate?this.plantingEndDate:this.workEndDate}&exclude_planting_id=${this.pastPlantingId}`).then(res => {
                this.pastPlantingArea = res[0].planted_area
                this.pastRemainingArea = res[0].remaining_area
            }).catch(() => {
                this.$toasted.error('データの取得に失敗しました。')
            })
        }
    }

    async callMountedLogic(): Promise<void> {

        if (this.id !== undefined && this.id !== '') {
           await this.$apiClient.doRequest('get', `${this.workerGoalBaseUrl}/${this.workerGoalId}`).then(res => { 
                this.selectedAgriFieldId = res.workerGoalItems.agriFieldId
                this.titleName = res.workerGoalItems.title
                this.selectedCropId = res.workerGoalItems.cropId
                this.selectedPlantingId = res.workerGoalItems.plantingId
                this.selectedWorkItemId = res.workerGoalItems.workItemId
                this.selectedWorkUnitId = res.workerGoalItems.workUnitId
                this.previousSelectedWorkUnitId = res.workerGoalItems.workUnitId
                this.selectedStartDate = res.workerGoalItems.workStartDate
                this.selectedEndDate = res.workerGoalItems.workEndDate
                this.isworkUnitExists = res.workerGoalItems.workUnitExists
                if(res.workerGoalItems.selectedOption!=""){
                    this.selectedOption = res.workerGoalItems.selectedOption
                }

                this.table2Workers = res.workerGoalData
                setTimeout(() => {
                this.workers = this.workers.filter(worker => 
                    !this.table2Workers.some(table2Worker => table2Worker.workerId === worker.id)
                );
               },200);
               this.selectedWorkUnitName = this.workunits.find(item=>item.id==this.selectedWorkUnitId)?.name

                this.workerRightTableSort();
                this.changeAgriField()
                this.recalculateAllWorkers();
            });       
        }
    }

    private saveRecord(){
        if (!this.validation()) {
            return false
        }
        const data = {
            title : this.titleName,
            crop_id: this.selectedCropId,
            agri_field_id : this.selectedAgriFieldId,
            work_item_id : this.selectedWorkItemId,
            planting_id : this.selectedPlantingId,
            work_unit_id : this.selectedWorkUnitId,
            work_start_date : this.selectedPlantingId?null:this.selectedStartDate,
            work_end_date :  this.selectedPlantingId?null:this.selectedEndDate,
            isValidationNeeded: this.isValidationNeeded,
            selectedOption: this.selectedOption,
            
            workerGoalData: this.table2Workers.map(w => ({
                worker_id: w.id ? w.id : w.workerId,
                past_goal: w.pastGoalValue,
                past_actual: w.pastActualValue,
                goal_value:w.goalValue,
                multiplication_rate: w.multiplicationRate,
                final_goal_value: w.finalGoalValue,
                reference_planting: w.plantingId,
                past_goal_unit_id:w.pastGoalUnitId,
                goal_unit_id:w.goalUnitId,
                past_actual_unit_id:w.pastActualUnitId
            })),
        }
       
        let property: {
            method: 'post' | 'put',
            url: string,
            message: string,
        } = {
            method: 'post',
            url: this.workerGoalBaseUrl,
            message: '保存しました。'
        }
        if (this.mode === 'edit') {
            if(this.isValidationNeeded && !window.confirm("内容を上書きして保存します。よろしいですか。")) {
                return false
            }
            property = {
                method: 'put',
                url: `${this.workerGoalBaseUrl}/${this.workerGoalId}`,
                message: '変更を保存しました。'
            }
        }
        this.doRequest(property.method, property.url, data)
            .then(res => {
                const promise: Promise<{ id: string }>[] = []
                Promise.all(promise).then(() => {
                    this.isValidationNeeded = true;
                    this.$toasted.success(property.message)
                    this.$emit('update:isRefresh', true);
                    this.$store.dispatch('doUpdateIsInputChanged', false);
                    this.closeModal();
                })
            })
        return true
    }

    public async doRequest(method: "get"|"post"|"put"|"delete", url: string, params?: any) {
        const accessToken = store.getters.accsessToken
        const tenantId = this.$apiClient.getTenantId() || store.getters.tenantId;
        const config: AxiosRequestConfig = {
          url: `${this.apiServerBaseUrl}${url}`,
          method: method,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
            'agri-tenant-id': tenantId
          },
          data: params,
          withCredentials: true
        }
        try {
          const res = await axios(config);
          return res.data;
        } catch (error) {
          if (error.response.status === 401) {
            await this.$apiClient.getAccessToken()
          }
          if (error.response.status === 400 && error.response.data?.message?.includes("よろしいですか？")) {
            const result = window.confirm("同一条件（圃場、作目、作付名、作業期間、作業項目）の作業目標が存在しますが、よろしいですか？")
            if (result) {
              this.isValidationNeeded = false;
              this.saveRecord();
            }
            Promise.reject(error.response);
          } else {
            this.$toasted.error('保存に失敗しました。');
            this.isValidationNeeded = true;
            this.$apiClient.errorAlert(error.response.status, error.response.data?.message)
          }
          return Promise.reject(error.response)
        }
    }

    private validation(): boolean {
        const errmsg: string[] = []
        if (this.titleName == null || this.titleName.trim() == "") {
            errmsg.push('タイトルを入力してください。')
        } else if (this.titleName.length > 255) {
            errmsg.push(`タイトルは255文字以内で入力してください（現在は${this.titleName.length}文字）`)
        }

        if (this.selectedWorkItemId == null) {
            errmsg.push('作業項目を選択してください。')
        }

        if(this.selectedCropId == null){
            errmsg.push('作目を選択してください。')
        }

        if(this.selectedWorkUnitId == null){
            errmsg.push('単位を選択してください。')
        }
        if (this.selectedPlantingId == null && (this.selectedStartDate == null || this.selectedStartDate == "")) {
            errmsg.push('開始日を選択してください。')
        }
        if (this.selectedPlantingId == null && (this.selectedEndDate == null || this.selectedEndDate == "")) {
            errmsg.push('終了日を選択してください。')
        }
        if (this.selectedPlantingId == null && this.selectedEndDate != null && this.selectedEndDate != "" && this.selectedStartDate != null && this.selectedStartDate != "" && this.selectedStartDate > this.selectedEndDate){
            errmsg.push("「作業期間」の開始日は終了日よりも前の日付を選択してください。")
        }
        if(this.table2Workers.length == 0){
            errmsg.push('生産性目標設定してください。')
        }
        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }
        return true
    }

    async cancelRecord() {
        if (store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            } else {
                this.overallMagnification = 1.0;
                this.onOverallMagnificationChanged()
            }
            this.$store.dispatch('doUpdateIsInputChanged', false);
            if (this.id !== undefined && this.id !== '') {
                this.initCheck()
                this.getWorkers()
                this.callMountedLogic()
                this.onOverallMagnificationChanged()
            } else {
                this.init()
            }
        }
    }

    deleteRecord(): void {
        const confirm = window.confirm('削除しますか？')
        if (confirm) {
            this.$apiClient.doRequest('delete', `${this.workerGoalBaseUrl}/${this.workerGoalId}`)
                .then(() => {
                    this.$toasted.success('削除しました。')
                    this.$store.dispatch('doUpdateIsInputChanged', false);
                    this.closeModal()
                    this.$emit('update:isRefresh', true);
                })
                .catch(() => {
                    this.$toasted.error('削除に失敗しました。')
                })
        } else {
            this.$toasted.success('削除がキャンセルされました。')
        }
    }

    applySelection() {
        if (this.selectedWorkers.length === 0) {
            return window.alert("表①に作業者を選択してください。");
        }
      
        let shouldShowAlert = false;
        let alertMessage = ''; 
      
        this.selectedWorkers.forEach(worker => {
          const finalGoalValue = worker.finalGoalValue !== undefined
            ? worker.finalGoalValue
            : this.selectedOption === '過去目標'
            ? this.workers.find(w => w.id === worker.id)?.finalGoalValue
            : this.selectedOption === '過去実績'
            ? this.workers.find(w => w.id === worker.id)?.finalActualValue
            : worker.goalValue;

            if ((worker.finalGoalValue && worker.finalGoalValue.toString().length > 8) || (worker.goalValue && worker.goalValue.toString().length > 8)) {
                alertMessage += `${worker.name || worker.id}さんの確定目標値は0より大きい整数部8桁までの数値を入力してください。\n`;
                shouldShowAlert = true;
            }

            if (
                ((worker.pastActualValue !== undefined || worker.pastActualValue === 0) && worker.finalGoalValue == 0) || 
                ((worker.pastGoalValue !== undefined || worker.pastGoalValue === 0) && worker.finalGoalValue == 0) || 
                (worker.finalGoalValue == 0 && worker.goalValue == null)
            ) {
                    alertMessage += `${worker.name || worker.id}さんの確定目標値は0より大きい数値を入力してください。\n`;
                    shouldShowAlert = true;
                }

            if((worker.pastGoalValue > 0 || worker.pastActualValue >0) && worker.multiplicationRate == 0 && worker.goalValue ==0 && (finalGoalValue === undefined || finalGoalValue === null)){
                alertMessage += `${worker.name || worker.id}さんの確定目標値を入力してください。\n`;
                shouldShowAlert = true;
            }
      
            if (finalGoalValue == null && worker.goalValue == null) {
                alertMessage += `${worker.name || worker.id}さんの確定目標値を入力してください。\n`;
                shouldShowAlert = true;
            }

            if ((worker.pastGoalValue === 0 && worker.pastActualValue === 0 && worker.goalValue === 0 && worker.finalGoalValue === undefined) ||
                (this.selectedOption === '過去実績' && worker.pastActualValue === 0 && worker.finalGoalValue == null) ||
                (this.selectedOption === '過去目標' && worker.pastGoalValue === 0 && (worker.finalGoalValue === undefined || worker.finalGoalValue == null)))
                {
                alertMessage += `${worker.name || worker.id}さんの確定目標値を入力してください。\n`;
                shouldShowAlert = true;
                }
            });

            if (shouldShowAlert) {
                return alert(alertMessage); 
            }
      
        this.selectedWorkers.forEach(worker => {
          const index = this.workers.findIndex(w => w.id === worker.id);
          if (index !== -1) {
            const finalGoalValue = worker.finalGoalValue !== undefined
              ? worker.finalGoalValue
              : this.selectedOption === '過去目標'
              ? this.workers[index].finalGoalValue
              : this.selectedOption === '過去実績'
              ? this.workers[index].finalActualValue
              : worker.goalValue;
      
            this.table2Workers.push({
              ...worker,
              pastGoalValue: worker.pastGoalValue === 0 ? 0 : worker.pastGoalValue,
              pastActualValue: worker.pastActualValue === 0 ? 0 : worker.pastActualValue,
              goalValue: worker.goalValue ? worker.goalValue : '',
              pastGoalUnitName: this.pastGoalWorkUnitName,
              pastGoalUnitId: this.workunits.find(item => item.name === this.pastGoalWorkUnitName)?.id,
              pastActualUnitName:this.pastGoalWorkUnitName?this.pastGoalWorkUnitName:this.selectedWorkUnitName,
              pastActualUnitId:this.workunits.find(item=>item.name==this.selectedWorkUnitName)?.id,
              goalUnitName: this.pastGoalWorkUnitName ?this.pastGoalWorkUnitName: this.selectedWorkUnitName,
              goalUnitId: this.workunits.find(item => item.name === ( this.pastGoalWorkUnitName ?this.pastGoalWorkUnitName: this.selectedWorkUnitName))?.id,
              workerId: worker.id,
              finalGoalValue: (worker.goalValue !== undefined && (worker.finalGoalValue === undefined || worker.finalGoalValue == null))
                ? worker.goalValue
                : (worker.actualValue !== undefined && (worker.finalGoalValue === undefined || worker.finalGoalValue == null))
                  ? worker.actualValue
                  : worker.finalGoalValue,
              multiplicationRate: worker.goalValue ? worker.multiplicationRate.toFixed(1) : null
            });
            this.workers.splice(index, 1);
          }
        });
        this.inputChanged();
        this.workerRightTableSort();
        this.selectedWorkers = [];
    }      

      private workerRightTableSort(){
        this.table2Workers.sort((a: any, b: any) => a.name.localeCompare(b.name));
        const workerAdmin = this.table2Workers.filter(user => user.authority === "ADMIN");
        const workerUser = this.table2Workers.filter(user => user.authority === "USER");
        this.table2Workers = workerAdmin.concat(workerUser);
      }

    remandSelection() {
        if (this.selectedTable2Workers.length == 0){
            return window.alert("表②に作業者を選択してください。");
        }
        const workersToRemand = this.table2Workers.filter(worker => this.selectedTable2Workers.includes(worker.id || worker.workerId))
        .map(({ workerId, name, authority }) => ({
            id: workerId,
            name,
            authority,
            pastGoalValue: null,
            pastActualValue: null,
            multiplicationRate: null,
            goalValue: null,
            finalGoalValue: null,
            referencePlanting: null
        }));      
        this.table2Workers = this.table2Workers.filter(worker => !this.selectedTable2Workers.includes(worker.id ? worker.id : worker.workerId));
        this.workers.push(...workersToRemand);
        this.selectedTable2Workers = [];
        this.workers = this.workers.map(worker => ({
            ...worker,
            multiplicationRate: worker.multiplicationRate === null ? this.overallMagnification : worker.multiplicationRate
        }));
        this.workerSort();
        if(this.selectedPastPerformance!=''){
            this.closePastPerformanceModal(this.selectedPastPerformance);
        }
        if(this.selectedGoalRecordId!=null){
            this.closeReferencePlantingModal(this.selectedGoalRecordId);
        }
        this.inputChanged();
        
    }
  
      recalculateAllWorkers() {
        this.workers.forEach(worker => {
          this.calculatedGoal(worker);
        });
      }

      private getGoalMultiplier(worker: Worker): number {
        if(worker.multiplicationRate === undefined){
            worker.multiplicationRate = this.overallMagnification
            this.calculatedGoal(worker)
        }
        return worker.multiplicationRate;
    }

    private updateGoalMultiplier(event: Event, worker: Worker) {
        const inputElement = event.target as HTMLInputElement;
        let currentValue = inputElement.value;

        if (currentValue === '') {
            inputElement.value = '0'; 
            inputElement.dispatchEvent(new Event('input')); 
            currentValue = '0'; 
        }
        const pattern = /^\d*\.?\d{0,1}$/;
        if (!pattern.test(currentValue)) {
            currentValue = currentValue.slice(0, -1);
            inputElement.value = currentValue;
            return;
        }
        const parsedValue = parseFloat(currentValue);
        this.$set(worker, 'multiplicationRate', parsedValue);
        this.calculatedGoal(worker);
    }
    
    //  private updateFinalGoalValue(event: Event, worker: Worker){
    //     const val = (event.target as HTMLInputElement).value;
    //     this.$set(worker , 'finalGoalValue', val);
    //  }

      onOverallMagnificationChanged() { 
        setTimeout(() => {
            this.workers.forEach(worker => {
                this.$set(worker, 'multiplicationRate', this.overallMagnification);
                this.calculatedGoal(worker);
                this.getGoalMultiplier(worker);
            });
        }, 500);
        if (this.overallMagnification > 1.0 || this.overallMagnification < 1.0) {
            this.inputChanged();
        }
      }

      get formattedOverallMagnification() {
        return this.overallMagnification === 0 ? '0' : this.overallMagnification.toFixed(1);
      }
      
      set formattedOverallMagnification(value: string) {
        this.overallMagnification = parseFloat(value);
      }

      getFormattedMultiplicationRate(worker: Worker) {
    if (worker && typeof worker.multiplicationRate === 'number') {
        const value = worker.multiplicationRate === 0 ? '0' : worker.multiplicationRate.toFixed(1);
        return value;
    }
    return '';
    }
      
      setFormattedMultiplicationRate(value: string,  worker: Worker) {
        worker.multiplicationRate = parseFloat(value);
      }

      public validateInputDecimal(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        const currentValue = inputElement.value;
        if (currentValue === '') {
            inputElement.value = '0'; 
            inputElement.dispatchEvent(new Event('input')); 
        }
        const pattern = /^\d*\.?\d{0,1}$/;
        if (!pattern.test(currentValue)) {
            inputElement.value = currentValue.slice(0, -1);
            inputElement.dispatchEvent(new Event('input'));
        }
    }

    private calculatedGoal(worker: Worker) {
        const referenceGoal = this.workers.find(goal => goal.id === worker.id);
        if (referenceGoal) {
            if (this.selectedOption === '過去目標'&& referenceGoal.pastGoalValue != null) {
                const goalValue = referenceGoal.pastGoalValue * this.getGoalMultiplier(worker);
                this.$set(worker, 'goalValue', Math.round(goalValue));
            } else if (this.selectedOption === '過去実績'&&referenceGoal.pastActualValue!=null){
                const actualGoal = referenceGoal.pastActualValue * this.getGoalMultiplier(worker);
                this.$set(worker, 'goalValue', Math.round(actualGoal));
            } else {
                this.$set(worker, 'goalValue', null);
            }
        }
    }

    private onChangeAgriField(){
        this.changeAgriField()
        this.inputChanged()
    }

    private changeAgriField() {
        if (this.selectedAgriFieldId != null && this.selectedPlantingId != null) {
            const selectedPlanting = this.plantings.filter(p => this.selectedPlantingId == p.id)
            const selectedStartDate = selectedPlanting[0].work_start_date
            const selectedEndDate = selectedPlanting[0].work_end_date
            this.$apiClient.doRequest('get', `/agri_fields/remaining_areas?agri_fields=${this.selectedAgriFieldId}&work_start_date=${selectedStartDate}&work_end_date=${selectedEndDate}&exclude_planting_id=${this.selectedPlantingId}`).then(res => {
                this.agriPlantedArea = res[0].planted_area
                this.agriRemainingArea = res[0].remaining_area
            }).catch(() => {
                this.$toasted.error('データの取得に失敗しました。')
            })
        }else{
            this.agriPlantedArea = ''
            this.agriRemainingArea = ''
        }
    }

    private getUnitName(){
        let isAlertTriggered = false; 

        for (const worker of this.workers) {
            if ((worker.finalGoalValue != null || 
                 worker.goalValue != null || 
                 worker.pastGoalValue != null || 
                 worker.pastActualValue != null || 
                 this.selectedWorkers.length > 0 || worker.multiplicationRate != 1.0) && !isAlertTriggered) {
                this.unitChangeAlert();
                isAlertTriggered = true; 
                break; 
            } else {
                this.selectedWorkUnitName = this.workunits.find(item => item.id == this.selectedWorkUnitId)?.name;
            }
        }
    
        if (this.table2Workers.length > 0 && !isAlertTriggered) {
            this.unitChangeAlert();
        }
        if (!isAlertTriggered && this.table2Workers.length <= 0) {
            this.previousSelectedWorkUnitId = this.selectedWorkUnitId;
        }
    }

    private unitChangeAlert(){
        const result = window.confirm('生産性目標設定表の値がクリアされます。よろしいですか？');
          setTimeout(() => {
            if (result) {
              this.previousSelectedWorkUnitId = this.selectedWorkUnitId;
              this.overallMagnification = 1.0;
              this.applyMultiplierToWorkers();
              this.pastPlantingName = '';
              this.pastPlantingId = '';
              this.pastAgriFieldName = '';
              this.pastPlantingArea = null;
              this.pastRemainingArea = null;
              this.selectedWorkers = [];
              this.pastGoalWorkUnitName = '';
              this.selectedPastPerformance = '';
              this.workers = [];
              this.getWorkers();
              this.onOverallMagnificationChanged()
              this.inputChanged();
            } else {
              this.selectedWorkUnitId = this.previousSelectedWorkUnitId;
            }
            this.selectedWorkUnitName = this.workunits.find(item => item.id == this.selectedWorkUnitId)?.name;
            this.recalculateAllWorkers();
            return;  
          }, 50);
    }

    get filteredWorkUnits() {
        return this.workunits.filter(wu => this.selectedWorkUnitId == wu.id || !wu.is_hidden)
    }

    get filteredPlantings() {
        if (this.selectedCropId != null) {
            return this.plantings.filter(p => (p.crop.id === this.selectedCropId && !p.is_hidden) || this.selectedPlantingId == p.id);
        } else {
            return this.plantings.filter(p => !p.is_hidden || this.selectedPlantingId == p.id);
        }
    }

    handlePlantingSelect() {
        if (this.selectedPlantingId != null) {
            const selectedPlanting = this.plantings.find(p => p.id === this.selectedPlantingId);
            if (selectedPlanting) {
                this.selectedCropId = selectedPlanting.crop.id;
            }
            this.changeAgriField();
            this.inputChanged();
        }
    }

    handleCropSelect() {
        this.selectedPlantingId = null
        this.inputChanged();
    }

    private updateItems() {
        this.getWorkUnits()
    }

    formatBigvalue(amount: any): number | string {
        if (amount == null || amount === '') { 
            return "";
        }
        const roundedAmount = Math.round(Number(amount) * 100) / 100;
        return roundedAmount;
    }

    private clear(){
        const hasFinalGoalValue = this.workers.some(item => item.finalGoalValue !== null && item.finalGoalValue !== undefined);
        if(hasFinalGoalValue==true){
        const result = window.confirm('確定目標値がクリアされます。よろしいですか？');
            if (!result) {
                return false;
            } else {
                this.workers.forEach(worker => {
                    this.$set(worker, 'finalGoalValue', null);
                });
                this.inputChanged();
            }
        }
    }
    private bulkCopy(){
        this.workers.forEach(worker => {
            if(worker.goalValue !== null) {
                this.$set(worker, 'finalGoalValue', worker.goalValue);
                this.inputChanged();
            } else if(worker.goalValue == 0) {
                this.$set(worker, 'finalGoalValue', 0); 
                this.inputChanged();
            }
        });
    }
}
